import { map } from 'lodash';
import CollectionApi from 'client/api/v2/CollectionApi';

const allowedSearchFields = [
  'name',
];

const ownerTypes = {
  Default: 'default',
  Organization: 'organization',
  Provider: 'provider',
};

const ownerEndpoints = {
  [ownerTypes.Default]: '/api/v2/commandtemplates',
  [ownerTypes.Organization]: '/api/v2/organizations/{id}/commandtemplates',
  [ownerTypes.Provider]: '/api/v2/providers/{id}/commandtemplates',
};

class CustomCommandTemplatesApi extends CollectionApi {
  constructor() {
    super(ownerEndpoints[ownerTypes.Default], {
      skip: 0,
      limit: 100,
      sort: 'name',
      search: {
        fields: allowedSearchFields,
        searchTerm: '',
      },
    });
  }

  async fetchOwnedTemplates(objId, owner, skip, limit, sort, searchTerm, filters = []) {
    this.baseUrl = ownerEndpoints[owner].replace('{id}', objId);
    const response = await this.fetch(skip, limit, sort, searchTerm, null, filters);

    return CustomCommandTemplatesApi.sanitizeResults(response);
  }

  static sanitizeResults(data) {
    const { totalCount } = data;
    let { results } = data;

    results = map(results, (template) => ({
      ...template,
      type: template.commandType, // Need this as type for application
      source: 'Custom',
    }));

    const model = {
      totalCount,
      results,
    };

    return model;
  }
}

export default new CustomCommandTemplatesApi();
